/**
 * Cabecalho que se esconde ao descer e volta ao subir.
 *
 * O sticky sozinho deixa a barra sempre a vista. Aqui a direcao do movimento e
 * que manda: descendo, o grupo inteiro (aviso + cabecalho) sai de cena; subindo,
 * volta na hora, em qualquer altura da pagina — nao so quando se chega ao topo.
 *
 * O estado vive num data-attribute e quem anima e o CSS, entao nao ha estilo
 * escrito por JS e a regra continua visivel em assets/theme.css.liquid.
 */
(() => {
  const grupo = document.querySelector('.header-sticky-group');
  if (!grupo) return;

  // O aviso do tema (estoque, erro do carrinho) nasce dentro de
  // [data-site-header]. Com o grupo escondido em translateY(-100%), o transform
  // vira o bloco de contencao do position: fixed e o aviso sai da tela junto.
  // No <body> ele volta a se medir pela janela e aparece no canto de baixo,
  // igual a quando o cabecalho esta visivel. O quick shop nao passa por aqui:
  // la o aviso vai para .modal-inner.
  new MutationObserver((mudancas) => {
    for (const mudanca of mudancas) {
      for (const no of mudanca.addedNodes) {
        if (no.nodeType === 1 && no.matches('.message-banner--container')) {
          document.body.appendChild(no);
        }
      }
    }
  }).observe(grupo, { childList: true, subtree: true });

  // Abaixo disto o movimento e tremor de trackpad, nao intencao de rolar.
  const LIMIAR = 6;

  // Enquanto o topo ainda esta perto, esconder atrapalha mais do que ajuda.
  const ZONA_DE_TOPO = 80;

  let ultimo = window.scrollY;
  let agendado = false;

  const aplicar = () => {
    agendado = false;
    const atual = window.scrollY;
    const delta = atual - ultimo;

    if (Math.abs(delta) < LIMIAR) return;
    ultimo = atual;

    // Com a busca ou um menu abertos, sumir com a barra tiraria da tela o que a
    // pessoa acabou de abrir.
    if (grupo.querySelector('.live-search--focused, [aria-expanded="true"]')) {
      grupo.dataset.hidden = 'false';
      return;
    }

    grupo.dataset.hidden = atual > ZONA_DE_TOPO && delta > 0 ? 'true' : 'false';
  };

  window.addEventListener(
    'scroll',
    () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(aplicar);
    },
    { passive: true }
  );

  // Teclado e leitor de tela navegam sem rolar; a barra precisa reaparecer.
  document.addEventListener('focusin', (evento) => {
    if (grupo.contains(evento.target)) grupo.dataset.hidden = 'false';
  });
})();
